<template>
  <div class="main-content">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <cargo-button-group-slider>
          <div>
            <el-button no="Add2" type="primary" :disabled="readonly" @click="pm.addBtnClickHandler()">{{ $t('SeaExport.Add2') }}</el-button>
            <el-button no="Delete" type="danger" :disabled="readonly" @click="pm.delBtnClickHandler()">{{ $t('SeaExport.Delete') }}</el-button>
            <el-button no="TemplateDownload" type="primary" @click="pm.downTemplateBtn_clickHandler()">{{ $t('SeaExport.TemplateDownload') }}</el-button>

            <el-upload
              :disabled="readonly"
              no="ExcelImport"
              :action="URL.seaExport.poItemsImportExcel"
              :headers="{sessionId:user.sessionId}"
              :data="{ jobUuid: job.uuid, jobNo: job.jobNo }"
              :show-file-list="false"
              accept=".xls, .xlsx"
              :before-upload="beforeUpload"
              :on-success="uploadSuccess"
              style="display: inline-block;margin-left: 5px;"
            >
              <el-button type="primary" :disabled="readonly">{{ $t('SeaExport.ExcelImport') }}</el-button>
            </el-upload>
            <el-button no="ExcelExport" type="primary" @click="pm.exportBtnClickHandler()">{{ $t('SeaExport.ExcelExport') }}</el-button>
            <el-button no="print" type="success" @click="pm.onBatchPrint()">{{ $t('SeaExport.print') }}</el-button>
            <el-button no="AddPackingInfo" type="primary" :disabled="isEdit" @click="pm.relatedContainerHandler()">{{ $t('SeaExport.AddPackingInfo') }}</el-button>
            <el-button no="RemovePackingInfo" type="primary" :disabled="isEdit" @click="pm.removeRelatedContainerHandler()">{{ $t('SeaExport.RemovePackingInfo') }}</el-button>
          </div>
        </cargo-button-group-slider>
      </div>
    </div>
    <div class="section" style="flex: 1;">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="poItems"
        style="width:100%;height:100%"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <!-- 添加装箱信息弹出窗 -->
    <trade-detail-container-linked-dialog
      :visible.sync="tradeDetailContainerLinkedDialog.visible"
      :job="job"
      :sel-po-items="tradeDetailContainerLinkedDialog.selPoItems"
      :related-container-usage="tradeDetailContainerLinkedDialog.relatedContainerUsage"
      @linkUsagesEventHandler="linkUsagesEventHandler"
    />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

import { TabTradeDetailBase } from './TabTradeDetailBase'
import { AbstractEntity as Job } from '@/class/model/AbstractEntity'
import TradeDetailContainerLinkedDialog
  from '@/components/Cargo/Job/tradeDetailContainerLinkedDialog'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import { basicCacheKeys as selectTypeNames } from '@/utils/cacheConfig'
import ColumnUtils from '@/utils/ColumnUtils'
import { formatNumberToThousands } from '@/utils'
import { isNumber } from '@/utils/validate'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import { deepCopy } from '@/utils/commonUtil'

export default {
  name: 'ReTabTradeDetail',
  components: { TradeDetailContainerLinkedDialog, cargoTemplateSelectorDialog, CargoButtonGroupSlider },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      URL,
      pm: new TabTradeDetailBase(this),
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: { // 添加编辑组件
          CargoAgGridCommonTextareaEditor
        }
      },
      rowData: [],
      gridApi: null,
      tradeDetailContainerLinkedDialog: {
        visible: false,
        selPoItems: [],
        relatedContainerUsage: []
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new RailwayExportJob(),
        category: 'POITEMS_RE',
        data: {
          POITEMS_UUID: []
        }
      },
      job: new Job().fillDefaultValue().getData(),
      poItems: [],
      delPoItemsUuids: [], // 删除的uuid
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    user() {
      return this.context.user || {}
    },
    columnDefs() {
      const columnDefs =
         [
           {
             headerName: '',
             field: '',
             headerCheckboxSelection: true,
             checkboxSelection: true,
             sortable: false,
             suppressMenu: true,
             suppressSizeToFit: true,
             resizable: false
           },
           {
             headerName: this.$t('SeaExport.ContainerSize'),
             headerTooltip: this.$t('SeaExport.ContainerSize'),
             field: 'eqSize',
             width: 100
           },
           {
             headerName: this.$t('SeaExport.ContainerType'),
             headerTooltip: this.$t('SeaExport.ContainerType'),
             field: 'eqType',
             width: 110
           },
           {
             headerName: this.$t('SeaExport.ContainerNo'),
             headerTooltip: this.$t('SeaExport.ContainerNo'),
             field: 'containerNo',
             width: 100
           },
           {
             headerName: this.$t('SeaExport.SealNo'),
             headerTooltip: this.$t('SeaExport.SealNo'),
             field: 'sealNo',
             width: 100
           },
           {
             headerName: this.$t('SeaExport.OrderNo'),
             headerTooltip: this.$t('SeaExport.OrderNo'),
             colId: 'orderNo',
             field: 'orderNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'ACPT',
             headerTooltip: 'ACPT',
             field: 'moduleCode',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.CaseNo'),
             headerTooltip: this.$t('SeaExport.CaseNo'),
             field: 'caseNo',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.Item'),
             headerTooltip: this.$t('SeaExport.Item'),
             field: 'itemNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.Sub'),
             headerTooltip: this.$t('SeaExport.Sub'),
             field: 'subItemNo',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'SUPPLY PARTS NO',
             headerTooltip: 'SUPPLY PARTS NO',
             field: 'supplyPartNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'ORDER PARTS NO',
             headerTooltip: 'ORDER PARTS NO',
             field: 'orderPartNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'HS CODE',
             headerTooltip: 'HS CODE',
             field: 'hsCode',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.isRelated'),
             headerTooltip: this.$t('SeaExport.isRelated'),
             field: 'related',
             width: 120,
             cellRenderer: (params) => {
               return this.relatedLabelFunc(params.value)
             }
           },
           {
             headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
             headerTooltip: this.$t('SeaExport.ChineseDescriptionOfGoods'),
             field: 'chineseCommodity',
             width: 120,
             editable: this.isEdit,
             cellEditor: 'CargoAgGridCommonTextareaEditor'
           },
           {
             headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
             headerTooltip: this.$t('SeaExport.EnglishDescriptionOfGoods'),
             field: 'englishCommodity',
             width: 120,
             editable: this.isEdit,
             cellEditor: 'CargoAgGridCommonTextareaEditor',
             cellEditorParams: {
               autoUppercase: this.isUppercaseByConfig
             }
           },
           {
             headerName: this.$t('SeaExport.Size2'),
             headerTooltip: this.$t('SeaExport.Size2'),
             field: 'itemSpec',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.CommodityClassification'),
             headerTooltip: this.$t('SeaExport.CommodityClassification'),
             field: 'customsCommodity',
             width: 100,
             editable: this.isEdit,
             cellEditor: 'CargoAgGridCommonTextareaEditor'
           },
           {
             headerName: this.$t('SeaExport.Qty'),
             headerTooltip: this.$t('SeaExport.Qty'),
             field: 'quantity',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.UnitOfMeasurement'),
             headerTooltip: this.$t('SeaExport.UnitOfMeasurement'),
             field: 'measure',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.NetWeight'),
             headerTooltip: this.$t('SeaExport.NetWeight'),
             field: 'netWeight',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: 'WEIGHT',
             headerTooltip: 'WEIGHT',
             field: 'grossWeight',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.Cubage'),
             headerTooltip: this.$t('SeaExport.Cubage'),
             field: 'cubage',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: 'AMOUNT',
             headerTooltip: 'AMOUNT',
             field: 'purchaseAmount',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: 'AMOUNT(RMB)',
             headerTooltip: 'AMOUNT(RMB)',
             field: 'purchaseAmountRMB',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: false,
               tag: 'span',
               attrs: {
                 textConverter: (val, data) => {
                   return this.purchaseAmountRMBLabelFun(data)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.CustomsDutyRate'),
             headerTooltip: this.$t('SeaExport.CustomsDutyRate'),
             field: 'purchaseTariffRate',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.CustomsDuties'),
             headerTooltip: this.$t('SeaExport.CustomsDuties'),
             field: 'purchaseTariffAmount',
             width: 120,
             cellRenderer: params => {
               return ColumnUtils.numberColumnLabelFunc(params.value, 2)
             }
           },
           {
             headerName: this.$t('SeaExport.IncrementValueDutyRate'),
             headerTooltip: this.$t('SeaExport.IncrementValueDutyRate'),
             field: 'purchaseValRate',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 // complexTextConverter: (data, val) => {
                 //   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 // },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.IncrementValueDuty'),
             headerTooltip: this.$t('SeaExport.IncrementValueDuty'),
             field: 'purchaseValAmount',
             width: 120,
             cellRenderer: params => {
               return ColumnUtils.numberColumnLabelFunc(params.value, 2)
             }
           },
           {
             headerName: this.$t('SeaExport.ConsumptionDutyRate'),
             headerTooltip: this.$t('SeaExport.ConsumptionDutyRate'),
             field: 'purchaseExciseRate',
             width: 110,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.ConsumptionDuty'),
             headerTooltip: this.$t('SeaExport.ConsumptionDuty'),
             field: 'purchaseExciseAmount',
             width: 100,
             cellRenderer: params => {
               return ColumnUtils.numberColumnLabelFunc(params.value, 2)
             }
           },
           {
             headerName: this.$t('SeaExport.ConsolidatedTax'),
             headerTooltip: this.$t('SeaExport.ConsolidatedTax'),
             field: 'totalRateAmount',
             width: 100,
             cellRenderer: (params) => {
               return this.totalRateAmountLabelFun(params.data)
             }
           },
           {
             headerName: this.$t('SeaExport.Currency'),
             headerTooltip: this.$t('SeaExport.Currency'),
             field: 'purchaseCurrency',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               clearable: false,
               isEdit: this.isEdit,
               tag: 'cargo-advance-select',
               selectType: selectTypeNames.basic_data_Currency,
               tagValue: 'code',
               tagName: 'code'
             }
           },
           {
             headerName: this.$t('SeaExport.ExchangeRate'),
             headerTooltip: this.$t('SeaExport.ExchangeRate'),
             field: 'pruchaseExchangeRate',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 type: 'number',
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 6))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.CargoPrice'),
             headerTooltip: this.$t('SeaExport.CargoPrice'),
             field: 'sellPrice',
             width: 100,
             cellRenderer: (params) => {
               return params.data ? ColumnUtils.numberColumnLabelFunc(params.data.sellPrice, 2) : 0.00
             },
             cellStyle: () => {
               return { backgroundColor: '#EEEEEE' }
             }
           },
           {
             headerName: this.$t('SeaExport.Tax'),
             headerTooltip: this.$t('SeaExport.Tax'),
             field: 'sellValAmount',
             width: 100,
             cellRenderer: (params) => {
               return params.data ? ColumnUtils.numberColumnLabelFunc(params.data.sellValAmount, 2) : 0.00
             },
             cellStyle: () => {
               return { backgroundColor: '#EEEEEE' }
             }
           },
           {
             headerName: this.$t('SeaExport.TaxRate'),
             headerTooltip: this.$t('SeaExport.TaxRate'),
             field: 'sellValRate',
             width: 100,
             cellStyle: () => {
               return { backgroundColor: '#EEEEEE' }
             }
           }
         ]
      return columnDefs
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.job = row
      await this.pm.loadPoItems()
      if (this.isEdit && this.job.uuid) {
        this.$emit('syncData', { poItems: deepCopy(this.job.poItems) })
      }
      this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    },
    // 保存
    getSubmitData() {
      return {
        job: this.job,
        poItems: this.poItems,
        delPoItemsUuids: this.delPoItemsUuids
      }
    },
    beforeUpload(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        this.pm.onImportSucceeded(response.data)
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    relatedLabelFunc(value) {
      return value === 1 ? this.$t('Message.Yes') : this.$t('Message.No')
    },
    totalRateAmountLabelFun(data) {
      const poItems = data
      if (poItems) {
        return Number(poItems.purchaseTariffAmount + poItems.purchaseValAmount + poItems.purchaseExciseAmount).toFixed(2)
      }
      return ''
    },
    purchaseAmountRMBLabelFun(data) {
      var poItems = data
      if (poItems) {
        return (Math.round(poItems.purchaseAmount * poItems.pruchaseExchangeRate)).toFixed(2)
      }
      return ''
    },
    // 添加装箱信息(选择后逻辑处理)
    linkUsagesEventHandler(data) {
      this.pm.linkUsagesEventHandler(data)
    }
  }
}
</script>
